module.exports = __webpack_public_path__ + "static/media/installation.8cfbad56.png";